import { css } from '@emotion/react'

import Colours from '@thebeansgroup/ui_style_helpers/colours'

export const container = css`
  text-align: left;
  font-size: 12px;
  line-height: 1.5;
  color: ${Colours('alertRed', '300')};
  margin-top: 4px;
`

export const button = {
  background: 'none',
  border: 'none',
  padding: '0',
  margin: '0',
  fontSize: 'inherit',
  textDecoration: 'underline'
}
